import './StatsCard.css';

const StatsCard = ({title, number}) => {

    return (

        <div className="stats-card">

            <div>

                <p>{title}</p>

                <h2>{number}</h2>

            </div>

            <span>+12%</span>

        </div>

    );
}

export default StatsCard;